import { render, staticRenderFns } from "./StatementList.vue?vue&type=template&id=1bae2a26&scoped=true"
import script from "./StatementList.vue?vue&type=script&lang=js"
export * from "./StatementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bae2a26",
  null
  
)

export default component.exports